export const ORDER_STATUS = {
  SHIPPED: "Shipped",
  IN_PURSUIT: "In Pursuit",
  CANCELLED: "Cancelled",
};

export const PICKUP_OR_DELIVERY = {
  "pickup": "Pick Up",
  "delivery": "Delivery"
}

export const NOTIFIABLE_LINK = {
  Order: "order",
  Subscription: "subscriptions",
  User: "account",
  Pharmacy: "pharmacies",
  Encounter: "subscriptions",
}

export const DAUCHI_EMAIL = "hello@dauchi.com";
export const DAUCHI_SUPPORT_EMAIL = "support@dauchi.com";
